import axios from 'axios'
import {actionTypes} from '@/commons/constants'
import {AzSearchUrlBuilder} from '@azinformatica/loki'

export default {
    async [actionTypes.ORGANIZACAO_PAPEL_SIGNATARIO.BUSCAR]({state}, parametros) {
        const organizacaoId = state.login.organizacaoPlano.organizacaoId
        const {filtros, paginacao} = parametros

        const url = AzSearchUrlBuilder.build(`api/organizacoes-papeis-signatarios/organizacoes/${organizacaoId}/paginado`, filtros, paginacao)
        const {data} = await axios.get(url)

        return data
    },

    async [actionTypes.ORGANIZACAO_PAPEL_SIGNATARIO.BUSCAR_TODOS]({state}) {
        const organizacaoId = state.login.organizacaoPlano.organizacaoId
        const {data} = await axios.get(`api/organizacoes-papeis-signatarios/organizacoes/${organizacaoId}/todos`)
        return data
    },

    async [actionTypes.ORGANIZACAO_PAPEL_SIGNATARIO.CRIAR]({state}, payload) {
        const organizacaoId = state.login.organizacaoPlano.organizacaoId
        await axios.post(`api/organizacoes-papeis-signatarios/organizacoes/${organizacaoId}/novo`, payload)
    },


    async [actionTypes.ORGANIZACAO_PAPEL_SIGNATARIO.EDITAR]({state}, {papelId, payload}) {
        const organizacaoId = state.login.organizacaoPlano.organizacaoId
        await axios.put(`api/organizacoes-papeis-signatarios/organizacoes/${organizacaoId}/papeis/${papelId}`, payload)
    },
}
